<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card color="white" elevation="0" style="border-radius: 20px !important">
      <v-card-title class="warning-color" style="border-radius: 20px !important">
        الاقسام
        <v-spacer></v-spacer>

        <v-text-field rounded v-model="search" outlined append-icon="mdi-magnify" label="بحث" single-line hide-details></v-text-field>
        <div style="width: 20px"></div>
        <AddSection @reloadTask="initialData()" />
      </v-card-title>
      <v-data-table :headers="headers" :items="ItemsFilter" :items-per-page="15" class="table-content table-warning-color">
        <template v-slot:[`item.sectionImage`]="{ item }">
          <v-avatar size="40">
            <img :src="`${$store.state.apiUrl}/${item.sectionImage}`" alt="" />
          </v-avatar>
        </template>

        <template v-slot:[`item.index`]="{ index }">
          <h4 style="padding: 0 3px">{{ index + 1 }}</h4>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <!-- <Images :images="item.images" style="display: inline-block" /> -->

          <v-btn icon @click="dialog = false">
            <DeleteSection :dataToDelete="item" @reloadTask="initialData()" v-if="$store.state.userData.roleId == 1" />
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import AddSection from "./section/AddSection.vue";
import DeleteSection from "./section/DeleteSection.vue";
export default {
  components: {
    AddSection,
    DeleteSection,
  },
  data: () => ({
    overlay: false,
    search: "",
    sections: [],
    headers: [
      { text: "التسلسل", value: "index" },
      { text: "صورة القسم", value: "sectionImage" },
      { text: "اسم القسم", value: "sectionName" },
      { text: "وصف القسم", value: "sectionDescription" },
      { text: "الاجراءات", value: "actions" },
    ],
  }),
  created() {
    this.initialData();
  },
  methods: {
    initialData() {
      let self = this;

      self.overlay = true;
      self.$http
        .get(`${self.$store.state.apiUrl}/sections`, {
          headers: { Authorization: `Bearer ${self.$store.state.user}` },
        })
        .then((res) => {
          console.log(res.data);
          self.sections = res.data;
          self.overlay = false;
        });
    },
  },
  computed: {
    ItemsFilter() {
      if (this.search) {
        return this.sections.filter((item) => {
          return this.search
            .toLowerCase()
            .split(" ")
            .every((v) => item.sectionName.toLowerCase().includes(v));
        });
      } else {
        return this.sections;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
